<!-- HERO SECTION -->
<div class="relative p-0">
    <div class="w-full overflow-hidden hidden md:block relative" style="height: 700px;">
        <div class="absolute top-0 left-0 w-full h-full"
            style="background: linear-gradient(135deg, #000000 0%, #1a1a1a 50%, #36DEFB 100%);"></div>

        <div class="absolute top-0 left-0 w-full h-full flex align-items-center">
            <div class="grid w-full mx-auto px-4 md:px-6 lg:px-8" style="max-width: 1800px;">
                <div class="col-12 md:col-6 flex flex-column justify-content-center">
                    <span class="text-primary font-bold text-xl mb-3">BUSINESS MANAGEMENT SOFTWARE</span>
                    <h1 class="text-white font-bold mb-4 text-5xl md:text-6xl lg:text-7xl leading-tight">
                        One platform to run your business
                    </h1>
                    <p class="text-gray-300 font-normal text-lg md:text-xl leading-relaxed mb-5">
                        BMS by ESZES is a modular business suite: catalog and e-commerce, point of sale, bookings,
                        payments, loyalty, CRM, documents, Business Process Management System (workflows, cases &amp;
                        decisions), HR and accounting. Pick the modules you need; we host, integrate and support them.
                    </p>
                    <div class="flex gap-3 flex-wrap">
                        <button pButton label="Explore the platform" routerLink="/services"
                            class="p-button-lg p-button-primary p-button-rounded"></button>
                        <button pButton label="Try it free" routerLink="/free-software"
                            class="p-button-lg p-button-outlined p-button-secondary text-white border-white p-button-rounded"></button>
                    </div>
                </div>
                <div class="col-12 md:col-6 hidden md:flex align-items-center justify-content-center">
                    <div class="relative w-full flex justify-content-center">
                        <div class="keyboard-container animate-fadeInUp" data-prerender-skip>
                            <div class="keyboard shadow-8">
                                <div class="key-row">
                                    <div class="key" id="key-q">Q</div>
                                    <div class="key" id="key-w">W</div>
                                    <div class="key" id="key-e">
                                        E
                                        <span class="floating-letter letter-e">E</span>
                                    </div>
                                    <div class="key" id="key-r">R</div>
                                    <div class="key" id="key-t">T</div>
                                    <div class="key" id="key-y">Y</div>
                                    <div class="key" id="key-u">U</div>
                                    <div class="key" id="key-i">I</div>
                                    <div class="key" id="key-o">O</div>
                                    <div class="key" id="key-p">P</div>
                                </div>
                                <div class="key-row">
                                    <div class="key" id="key-a">A</div>
                                    <div class="key" id="key-s">
                                        S
                                        <span class="floating-letter letter-s">S</span>
                                    </div>
                                    <div class="key" id="key-d">D</div>
                                    <div class="key" id="key-f">F</div>
                                    <div class="key" id="key-g">G</div>
                                    <div class="key" id="key-h">H</div>
                                    <div class="key" id="key-j">J</div>
                                    <div class="key" id="key-k">K</div>
                                    <div class="key" id="key-l">L</div>
                                </div>
                                <div class="key-row">
                                    <div class="key" id="key-z">
                                        Z
                                        <span class="floating-letter letter-z">Z</span>
                                    </div>
                                    <div class="key" id="key-x">X</div>
                                    <div class="key" id="key-c">C</div>
                                    <div class="key" id="key-v">V</div>
                                    <div class="key" id="key-b">B</div>
                                    <div class="key" id="key-n">N</div>
                                    <div class="key" id="key-m">M</div>
                                </div>
                                <div class="key-row">
                                    <div class="key space"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Mobile Hero: sized by its content, so no empty gradient band above or below the copy -->
    <div class="block md:hidden w-full px-4 py-7 text-center"
        style="background: linear-gradient(180deg, #000000 0%, #36DEFB 100%);">
        <span class="text-primary font-bold text-lg mb-3 block">BUSINESS MANAGEMENT SOFTWARE</span>
        <h1 class="text-white font-bold text-3xl mb-4 leading-tight">
            One platform to run your business
        </h1>
        <p class="text-gray-300 text-base mb-5 leading-relaxed">
            Catalog, e-commerce, POS, bookings, payments, loyalty, CRM, documents, BPMS workflows &amp; cases, HR and accounting: one suite, one sign-in.
        </p>
        <div class="flex gap-3 justify-content-center flex-wrap">
            <button pButton label="Explore the platform" routerLink="/services" class="p-button-primary p-button-rounded"></button>
            <button pButton label="Try it free" routerLink="/free-software"
                class="p-button-outlined text-white border-white p-button-rounded"></button>
        </div>
    </div>
</div>

<!-- ABOUT SECTION -->
<section class="bg-white py-8">
    <div class="mx-auto px-4 md:px-6 lg:px-8" style="max-width: 1800px;">
        <div class="grid align-items-center">
            <div class="col-12 lg:col-6 mb-6 lg:mb-0">
                <div class="relative flex justify-content-center align-items-center">
                    <!-- Lottie Animation: sized by aspect ratio so phones get no blank band under it -->
                    <div class="w-full mx-auto" style="max-width: 40rem;">
                        <lottie-player src="assets/lottie/homepage-about.json" background="transparent" speed="1"
                            style="width: 100%; aspect-ratio: 4 / 3; max-height: 450px; display: block;" loop autoplay>
                        </lottie-player>
                    </div>
                </div>
            </div>
            <div class="col-12 lg:col-6 lg:pl-8">
                <span class="text-primary-deep font-bold text-xl block mb-3">ABOUT ESZES</span>
                <h2 class="text-900 text-4xl md:text-5xl lg:text-6xl font-bold mb-5 leading-tight">
                    Software built for the way <span class="text-primary-deep">businesses actually run</span>
                </h2>
                <p class="text-700 text-lg line-height-3 mb-6">
                    ESZES Consultancy &amp; Services, Thrissur, builds and operates BMS: a 16-module suite of business
                    applications that share one sign-in, fine-grained relationship-based permissions, one audit trail
                    and one set of data per customer. Every module ships with a staff web app and a REST and MCP API,
                    isolated per tenant in the cloud. Hotels, clinics, gyms, cafés, retailers and residential
                    communities run on it today.
                </p>
                <div class="grid mb-6">
                    <div class="col-12 sm:col-6 flex align-items-center gap-3 mb-4">
                        <i class="pi pi-check-circle text-primary text-3xl"></i>
                        <div>
                            <h3 class="text-900 text-xl font-bold mb-1">Isolated and audited</h3>
                            <p class="text-600 m-0">Per-tenant data, fine-grained permissions &amp; full revision history</p>
                        </div>
                    </div>
                    <div class="col-12 sm:col-6 flex align-items-center gap-3 mb-4">
                        <i class="pi pi-chart-line text-primary text-3xl"></i>
                        <div>
                            <h3 class="text-900 text-xl font-bold mb-1">Open by design</h3>
                            <p class="text-600 m-0">REST, Integration Platform webhooks and MCP servers for AI agents</p>
                        </div>
                    </div>
                </div>
                <button pButton label="About ESZES" routerLink="/aboutus"
                    class="p-button-primary p-button-lg p-button-rounded px-6"></button>
            </div>
        </div>
    </div>
</section>

<!-- SERVICES SECTION - PROFESSIONAL DARK THEME -->
<section class="bg-gray-900 py-8 relative overflow-hidden">
    <!-- Decorative Background -->
    <div class="absolute top-0 left-0 w-full h-full opacity-10"
        style="background-image: radial-gradient(circle at 2px 2px, #36DEFB 1px, transparent 0); background-size: 30px 30px;">
    </div>

    <div class="mx-auto px-4 md:px-6 lg:px-8 relative z-1" style="max-width: 1800px;">
        <div class="text-center mb-8">
            <span class="text-primary font-bold text-xl block mb-3 uppercase tracking-widest">OUR SERVICES</span>
            <h2 class="text-white text-4xl md:text-5xl font-bold">What we offer</h2>
        </div>
        <div class="grid">
            <div class="col-12 md:col-6 lg:col-4 p-3" *ngFor="let service of services; let i = index">
                <div class="service-card bg-white-alpha-5 backdrop-blur-lg p-6 border-round-2xl shadow-2 h-full border-1 border-white-alpha-10 hover:border-primary hover:bg-white-alpha-10 flex flex-column animate-fadeInUp"
                    [style.animation-delay]="(i * 0.1) + 's'">
                    <div
                        class="icon-box w-4rem h-4rem bg-white-alpha-10 border-round-2xl flex align-items-center justify-content-center mb-6 shadow-2">
                        <i [class]="service.icon + ' text-primary text-3xl'"></i>
                    </div>
                    <h3 class="text-white text-2xl font-bold mb-4 transition-colors transition-duration-300">{{
                        service.title }}</h3>
                    <p class="text-gray-400 line-height-3 mb-6">{{ service.description }}</p>
                    <a routerLink="/services" [fragment]="service.id"
                        class="flex align-items-center gap-2 text-primary font-bold no-underline hover:text-white transition-colors transition-duration-300">
                        <span>Explore {{ service.title }}</span>
                        <i class="pi pi-arrow-right" aria-hidden="true"></i>
                    </a>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- WEB SOLUTIONS SECTION -->
<section class="ws-solutions-section py-8">
    <div class="mx-auto px-4 md:px-6 lg:px-8" style="max-width: 1800px;">
     

        <div class="grid align-items-center">

            <!-- LEFT: Detail Panel -->
            <div class="col-12 lg:col-5 pr-0 lg:pr-6">
                <div class="text-left mb-7">
            <span class="text-primary-deep font-bold text-xl block mb-3 uppercase tracking-widest">WHAT WE BUILD</span>
            <h2 class="text-900 text-4xl md:text-5xl font-bold">The BMS modules</h2>
        </div>
                <p class="text-700 text-lg line-height-3 mb-5">
                    The suite has sixteen modules that share one sign-in, fine-grained access control, one audit trail
                    and one API style; each is its own web app you can switch on per customer. The nine below are the
                    ones most customers start with. Click a module to see what it does; the rest (kitchen display,
                    digital signage, user management, organisation setup) are on the services page.
                </p>

                <!-- Solution Detail Card -->
                <div class="ws-active-card animate-fadeInUp">
                    <!-- Default to Items · Catalog (index 0) if null, otherwise show selected index -->
                    <ng-container *ngIf="(selectedSolutionIndex === null ? webSolutions[0] : webSolutions[selectedSolutionIndex]) as sol">
                        <div class="ws-active-card__icon">
                            <i [class]="sol.icon"></i>
                        </div>
                        <div class="ws-active-card__body">
                            <h3 class="ws-active-card__title">{{ sol.title }}</h3>
                            <p class="ws-active-card__desc">{{ sol.description }}</p>
                            <a routerLink="/services" [fragment]="sol.section"
                                class="inline-flex align-items-center gap-2 text-primary-deep font-bold no-underline hover:underline mt-2">
                                <span>See it on the services page</span>
                                <i class="pi pi-arrow-right" aria-hidden="true"></i>
                            </a>
                        </div>
                    </ng-container>
                </div>

                <!-- Solution Tabs (pill list) -->
                <div class="ws-tabs mt-5">
                    <button *ngFor="let sol of webSolutions; let i = index"
                        [class]="'ws-tab' + (selectedSolutionIndex === i ? ' ws-tab--active' : '')"
                        (click)="activateSolution(i)">
                        <i [class]="sol.icon"></i>
                        <span>{{ sol.title }}</span>
                    </button>
                </div>
            </div>

            <!-- RIGHT: Bubble Cluster (9 bubbles) -->
            <div class="col-12 lg:col-7 flex justify-content-center align-items-center">
                <div class="ws-bubble-cluster">
                    <!-- Decorative Orbital Paths -->
                    <div class="ws-orbit-ring ws-orbit-outer"></div>
                    <div class="ws-orbit-ring ws-orbit-inner"></div>
                    
                    <!-- Central Core -->
                    <div class="ws-core">
                        <span class="ws-core__brand">ESZES</span>
                        <div class="ws-core__pulse"></div>
                    </div>
                    
                    <div *ngFor="let sol of webSolutions; let i = index"
                        [ngClass]="['ws-bubble', 'ws-bubble--pos-' + i, selectedSolutionIndex === i ? 'ws-bubble--active' : '']"
                        (click)="activateSolution(i)">
                        <i [class]="sol.icon + ' ws-bubble-icon'"></i>
                        <span class="ws-bubble-label">{{ sol.title }}</span>
                    </div>
                </div>
            </div>

        </div>
    </div>
</section>



<!-- FREE SOFTWARE TEASER -->
<section class="bg-white py-8">
    <div class="mx-auto px-4 md:px-6 lg:px-8" style="max-width: 1200px;">
        <div class="grid align-items-center">
            <div class="col-12 lg:col-8">
                <span class="text-primary-deep font-bold text-lg uppercase tracking-widest block mb-3">Free business software for all</span>
                <h2 class="text-900 text-4xl md:text-5xl font-bold mb-3">Run our BMS apps on your own computer, free</h2>
                <p class="text-600 text-xl line-height-4 m-0">Snapcart pairs BMS Items (catalog) with BMS Ecom (orders). Download, run locally, keep your data on your machine.</p>
            </div>
            <div class="col-12 lg:col-4 flex lg:justify-content-end gap-3 flex-wrap mt-4 lg:mt-0">
                <button pButton label="About the free edition" icon="pi pi-arrow-right" iconPos="right" routerLink="/free-software"
                    class="p-button-primary p-button-rounded px-5 py-3 font-bold shadow-4"></button>
            </div>
        </div>
    </div>
</section>

<!-- CTA SECTION -->
<section class="bg-gray-900 py-6 relative overflow-hidden">
    <div class="absolute top-0 left-0 w-full h-full opacity-20"
        style="background: radial-gradient(circle at center, #36DEFB 0%, transparent 70%);"></div>
    <div class="mx-auto px-4 md:px-6 lg:px-8 text-center relative z-1" style="max-width: 1000px;">
        <h2 class="text-white text-3xl md:text-5xl font-bold mb-4 mt-0 lg:mt-6 tracking-tight">Ready to see BMS running?</h2>
        <p class="text-gray-400 text-lg mb-6 max-w-30rem mx-auto line-height-3">
            Try the free local edition on your own laptop today, or talk to us about a hosted tenant with the modules you need.
        </p>
        <div class="flex gap-3 justify-content-center flex-wrap mb-5">
            <button pButton label="Try it free" routerLink="/free-software"
                class="p-button-primary p-button-rounded px-6 py-3 font-bold text-base shadow-4 hover:shadow-8 transition-all transition-duration-300"></button>
            <button pButton label="Contact Us" routerLink="/contact"
                class="p-button-outlined p-button-secondary text-white border-white p-button-rounded px-6 py-3 font-bold text-base hover:bg-white-alpha-10 transition-all transition-duration-300"></button>
        </div>
    </div>
</section>